import { render, staticRenderFns } from "./stockout_index.vue?vue&type=template&id=130f3f13&scoped=true&"
import script from "./stockout_index.vue?vue&type=script&lang=js&"
export * from "./stockout_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130f3f13",
  null
  
)

export default component.exports